<template>
    <ContextMeterBase :message-stack="messageStack" :percentage="state.percentage" :current-checkpoint="state.activeCheckpoint" />
</template>

<script setup>
import ContextMeterBase from "~vue/Onboarding/ContextMeterBase.vue";
import { computed } from "vue";

const props = defineProps({
    text: { type: String, default: "" },
    messageStack: { type: Array, default: () => [] },
    checkpoints: { type: Array, default: () => [25, 100, 250, 350] },
});

const state = computed(() => {
    const textLength = props.text.length;

    let activeCheckpoint = -1;
    const percentage = Math.min((textLength / props.checkpoints[props.checkpoints.length - 1]) * 100, 100);

    if (textLength < props.checkpoints[0]) {
        activeCheckpoint = -1;
    } else if (textLength >= props.checkpoints[0] && textLength <= props.checkpoints[1]) {
        activeCheckpoint = 0;
    } else if (textLength > props.checkpoints[1] && textLength <= props.checkpoints[2]) {
        activeCheckpoint = 1;
    } else if (textLength > props.checkpoints[2] && textLength <= props.checkpoints[3]) {
        activeCheckpoint = 2;
    } else if (textLength > props.checkpoints[3]) {
        activeCheckpoint = 3;
    }

    return { activeCheckpoint, percentage: Math.min(percentage, 100) };
});
</script>
